
    import './styles.scoped.css';
    export default {
  "connector": "awsui_connector_gxp9y_absrc_9",
  "connector-hidden": "awsui_connector-hidden_gxp9y_absrc_13",
  "header": "awsui_header_gxp9y_absrc_17",
  "root": "awsui_root_gxp9y_absrc_21",
  "list": "awsui_list_gxp9y_absrc_54",
  "container": "awsui_container_gxp9y_absrc_59",
  "annotation": "awsui_annotation_gxp9y_absrc_64",
  "step-layout": "awsui_step-layout_gxp9y_absrc_69",
  "details": "awsui_details_gxp9y_absrc_75",
  "custom": "awsui_custom_gxp9y_absrc_81",
  "horizontal": "awsui_horizontal_gxp9y_absrc_85",
  "content": "awsui_content_gxp9y_absrc_121",
  "vertical": "awsui_vertical_gxp9y_absrc_135",
  "connector-continuation": "awsui_connector-continuation_gxp9y_absrc_149",
  "custom-vertical": "awsui_custom-vertical_gxp9y_absrc_167",
  "rail": "awsui_rail_gxp9y_absrc_167",
  "with-annotation": "awsui_with-annotation_gxp9y_absrc_190"
};
  